import {useSelector} from 'react-redux';
import Gleap from 'gleap';
import {useFetchCurrentUserQuery, User} from '../../store/features/Users/userService.ts';
import type {RootState} from '../../store/store';

const GLEAP_FORM_PREPROD = '996089f059d0d2f02d3e';
const GLEAP_FORM_PROD = 'ab9d7855c823ac53afe4';

/** "Had issues with this call? Report a problem" — opens the Gleap form with the call's details attached. */
export const ReportCallProblem = ({callData}: { callData: Record<string, unknown> }) => {
    const userId = useSelector((state: RootState) => state.auth.userId);
    const tenantId = useSelector((state: RootState) => state.auth.tenant);
    const {data: user = {} as User} = useFetchCurrentUserQuery(userId);

    const report = () => {
        Gleap.attachCustomData({
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            tenantId,
            ...callData,
        });
        Gleap.startClassicForm(window.location.href.includes('preprod') ? GLEAP_FORM_PREPROD : GLEAP_FORM_PROD, true);
    };

    return (
        <div className="flex items-center gap-2 text-footnote text-ink-muted">
            Had issues with this call?
            <button type="button" onClick={report} className="cursor-pointer font-semibold text-brand-ink hover:underline">
                Report a problem
            </button>
        </div>
    );
};
